import { useEffect } from "react";

import { FunctionOverrideKey } from "@keepeek/commons";
import { useRouter } from "next/router";

const CustomNavigationEvent = function () {
  const router = useRouter();

  useEffect(() => {
    const handleCustomNavigation = (event: CustomEvent) => {
      const path = event.detail.path;
      if (typeof path === "string") {
        router.push(path);
      } else {
        console.error("Invalid type for path {}", typeof path);
      }
    };

    window.addEventListener(
      FunctionOverrideKey.EnableCustomNavigationEvent,
      handleCustomNavigation,
    );

    return () => {
      window.removeEventListener(
        FunctionOverrideKey.EnableCustomNavigationEvent,
        handleCustomNavigation,
      );
    };
  }, [router]);

  return null;
};

export default CustomNavigationEvent;
